import React from 'react';

const RulerIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="3" />
    <path d="M7 7v10M12 7v5M17 7v8" />
  </svg>
);

const LocationIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

const objects = [
  {
    badge:    'Verfügbar',
    title:    'Bürofläche Tostedt',
    features: [
      { icon: <RulerIcon />, text: '136 m² Gesamtfläche' },
      { icon: <LocationIcon />, text: 'Tostedt, Landkreis Harburg' },
      { icon: null, text: 'Moderner Grundriss, gut erschlossen' },
      { icon: null, text: 'Ideal für Büro, Praxis oder Dienstleistung' },
    ],
  },
  {
    badge:    'Verfügbar',
    title:    'Praxisfläche',
    features: [
      { icon: <RulerIcon />, text: '139 m² Gesamtfläche' },
      { icon: <LocationIcon />, text: 'Großraum Hamburg / Bremen' },
      { icon: null, text: 'Barrierefrei zugänglich' },
      { icon: null, text: 'Geeignet für Gesundheit, Beratung, Therapie' },
    ],
  },
];

export default function MietinteresseSection() {
  return (
    <section className="section" id="mietinteresse">
      <div className="container">

        <div className="miete2__head">
          <span className="section-label">Mietinteresse</span>
          <h2 className="section-title">Aktuelle Objekte</h2>
          <p className="section-subtitle">
            Sie suchen Gewerbefläche in Norddeutschland?
            Sprechen Sie uns direkt an – wir finden die passende Lösung.
          </p>
        </div>

        <div className="miete2__grid">
          {objects.map(o => (
            <div key={o.title} className="miete2__card">
              <div className="miete2__bar" />
              <div className="miete2__body">
                <span className="miete2__badge">{o.badge}</span>
                <h3 className="miete2__title">{o.title}</h3>
                <ul className="miete2__features">
                  {o.features.map((f, i) => (
                    <li key={i} className="miete2__feature">
                      {f.icon && (
                        <span className="miete2__feat-icon">{f.icon}</span>
                      )}
                      {!f.icon && (
                        <span className="miete2__feat-icon" style={{ opacity: .35 }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        </span>
                      )}
                      {f.text}
                    </li>
                  ))}
                </ul>
                <div className="miete2__cta">
                  <a
                    href="mailto:info@huusmacher.de?subject=Anfrage%20Mietinteresse"
                    className="btn btn-outline btn-sm"
                  >
                    Anfrage senden
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
